import Vue from 'vue'
import VueRouter from 'vue-router'
import Calculator from '../views/Calculator.vue'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Register from '../views/Register.vue'
import AdviserHub from '../views/AdviserHub.vue'
import Utilities from '../views/Utilities.vue'
import OnePath from '../views/OnePath.vue'
import PartnersLife from '../views/PartnersLife.vue'
import Manager from '../views/Manager.vue'
import AdviserHome from '../views/AdviserHome.vue'
import ContactUs from '../views/ContactUs.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },  
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/adviserhub',
    name: 'AdviserHub',
    component: AdviserHub
  },
  {
    path: '/calculator',
    name: 'Calculator',
    component: Calculator
  },
  {
    path: '/Utilities',
    name: 'Utilities',
    component: Utilities
  },
  {
    path: '/OnePath',
    name: 'OnePath',
    component: OnePath
  },
  {
    path: '/PartnersLife',
    name: 'PartnersLife',
    component: PartnersLife
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/manager',
    name: 'Manager',
    component: Manager
  },
  {
    path: '/adviserhome',
    name: 'AdviserHome',
    component: AdviserHome
  },
  {
    path: '/contactus',
    name: 'ContactUs',
    component: ContactUs
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
